import { ROUTES } from "~/constant/route-list";

// ~/data/navLinks.ts
export const navLinks = [
  { id: "1", label: "Home", path: "/" },
  { id: "2", label: "Layanan Kami", path: ROUTES.LAYANAN_KAMI },
  { id: "3", label: "Galeri", path: "/gallery" },
  { id: "4", label: "Tentang Kami", path: ROUTES.TENTANG_KAMI },
];
